// extracted by mini-css-extract-plugin
export default {"textarea":"Confirm-module__textarea__gEKD3","link":"Confirm-module__link__AQD9L","body":"Confirm-module__body__MdwLK"};